import React, { createContext, useContext, useState } from 'react';

interface HeaderContextType {
  title: string;
  setTitle: (title: string) => void;
  defaultTitle: string;
  setDefaultTitle: (title: string) => void;
}

const HeaderContext = createContext<HeaderContextType | undefined>(undefined);

export const HeaderProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [title, setTitle] = useState('');
  const [defaultTitle, setDefaultTitle] = useState('');

  return (
    <HeaderContext.Provider value={{ title, setTitle, defaultTitle, setDefaultTitle }}>
      {children}
    </HeaderContext.Provider>
  );
};

export const useHeader = () => {
  const context = useContext(HeaderContext);
  if (context === undefined) {
    throw new Error('useHeader must be used within a HeaderProvider');
  }
  return context;
};